import React, { useState } from 'react';
import './InputArea.css';

function InputArea({ onSend, activeModel, onFileUpload }) {  // Added onFileUpload prop
  const [prompt, setPrompt] = useState('');

  const handleSend = () => {
    if (prompt.trim() !== '') {
      onSend(prompt);
      setPrompt('');
    }
  };

  const handleUpload = (event) => {
    const files = Array.from(event.target.files); // Ensure files are in an array
    if (files.length > 0) {
      onFileUpload(files);  // Pass files to the parent component's handler
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSend();
    }
  };

  return (
    <div className="input-area">
      <input
        type="file"
        id="file-upload"
        className="file-upload"
        onChange={handleUpload}
        multiple
      />
      <label htmlFor="file-upload" className="file-upload-label">
        <img src="attachment-icon.svg" alt="Upload" className="icon" />
      </label>
      <input
        type="text"
        className="text-input"
        placeholder="Type your message here..."
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      <button className="send-button" onClick={handleSend}>
        <img src="send-icon.svg" alt="Send" className="icon" />
      </button>
    </div>
  );
}

export default InputArea;

